/* eslint-disable no-template-curly-in-string */
import { useInjection } from 'inversify-react';
import { useEffect } from 'react';

import { getInkive } from '@desygner/ui-editor-sdk-inkive';

import { TYPES } from '../../../inversify.config';
import { IUserStoreInjector } from '../../../store';

export function AureliaAuthModal({
  onLogin,
}: {
  onLogin: (userToken: string, userHash?: string, apiKey?: string) => void;
}) {
  const useUserStore = useInjection<IUserStoreInjector>(TYPES.Store.User);
  const { isCredentialValid } = useUserStore();

  useEffect(() => {
    const handleLogin = (event: CustomEvent) => {
      if (!event.detail) return;

      onLogin(event.detail.token, event.detail.hash, event.detail.api_key);
    };

    document.addEventListener('access:modal.loggedin', handleLogin as EventListener, {
      once: true,
    });

    return () => {
      document.removeEventListener('access:modal.loggedin', handleLogin as EventListener);
    };
  }, [onLogin]);

  useEffect(() => {
    // TODO: handle case in Desygner where user enter an URL but has no credentials => can't load editor => has no inkive

    if (!isCredentialValid) {
      getInkive().Helpers.displayAccessModal();
    }
  }, [isCredentialValid]);

  return null;
}
